import { defineMessages } from 'react-intl';

export enum NoticeMessage {
	Delete = 'Delete',
	Discard = 'Discard',
	Change = 'Change',
	Confirm = 'Confirm',
	Submit = 'Submit',
	Reopen = 'Reopen',
	Close = 'Close',
	Cancel = 'Cancel',
	UpgradeNow = 'UpgradeNow',
	MakeInternal = 'MakeInternal',
	MakeExternal = 'MakeExternal',
	DeleteFormTitle = 'DeleteFormTitle',
	DeleteFormMsg = 'DeleteFormMsg',
	ChangeFormAvailabilityTitle = 'ChangeFormAvailabilityTitle',
	ChangeFormToInternalHeader = 'ChangeFormToInternalHeader',
	ChangeFormToInternalMsg = 'ChangeFormToInternalMsg',
	ChangeFormToExternalHeader = 'ChangeFormToExternalHeader',
	ChangeFormToExternalMsg = 'ChangeFormToExternalMsg',
	CancelEditFormTitle = 'CancelEditFormTitle',
	CancelEditFormMsg = 'CancelEditFormMsg',
	SubmitFormTitle = 'SubmitFormTitle',
	SubmitFormMsg = 'SubmitFormMsg',
	SubmitFormLockMsg = 'SubmitFormLockMsg',
	ReopenFormTitle = 'ReopenFormTitle',
	ReopenFormMsg = 'ReopenFormMsg',
	ErrorExplanations1 = 'ErrorExplanations1',
	ErrorExplanations2 = 'ErrorExplanations2',
	ErrorExplanations3 = 'ErrorExplanations3',
	ErrorExplanations4 = 'ErrorExplanations4',
}

export const IntlNoticeMessages: {
	Delete: {
		id: string;
		defaultMessage: string;
	};
	Discard: {
		id: string;
		defaultMessage: string;
	};
	Change: {
		id: string;
		defaultMessage: string;
	};
	Confirm: {
		id: string;
		defaultMessage: string;
	};
	Submit: {
		id: string;
		defaultMessage: string;
	};
	Reopen: {
		id: string;
		defaultMessage: string;
	};
	Close: {
		id: string;
		defaultMessage: string;
	};
	Cancel: {
		id: string;
		defaultMessage: string;
	};
	UpgradeNow: {
		id: string;
		defaultMessage: string;
	};
	MakeInternal: {
		id: string;
		defaultMessage: string;
	};
	MakeExternal: {
		id: string;
		defaultMessage: string;
	};
	DeleteFormTitle: {
		id: string;
		defaultMessage: string;
	};
	DeleteFormMsg: {
		id: string;
		defaultMessage: string;
	};
	ChangeFormAvailabilityTitle: {
		id: string;
		defaultMessage: string;
	};
	ChangeFormToInternalHeader: {
		id: string;
		defaultMessage: string;
	};
	ChangeFormToInternalMsg: {
		id: string;
		defaultMessage: string;
	};
	ChangeFormToExternalHeader: {
		id: string;
		defaultMessage: string;
	};
	ChangeFormToExternalMsg: {
		id: string;
		defaultMessage: string;
	};
	CancelEditFormTitle: {
		id: string;
		defaultMessage: string;
	};
	CancelEditFormMsg: {
		id: string;
		defaultMessage: string;
	};
	SubmitFormTitle: {
		id: string;
		defaultMessage: string;
	};
	SubmitFormMsg: {
		id: string;
		defaultMessage: string;
	};
	SubmitFormLockMsg: {
		id: string;
		defaultMessage: string;
	};
	ReopenFormTitle: {
		id: string;
		defaultMessage: string;
	};
	ReopenFormMsg: {
		id: string;
		defaultMessage: string;
	};
	ErrorExplanations1: {
		id: string;
		defaultMessage: string;
	};
	ErrorExplanations2: {
		id: string;
		defaultMessage: string;
	};
	ErrorExplanations3: {
		id: string;
		defaultMessage: string;
	};
	ErrorExplanations4: {
		id: string;
		defaultMessage: string;
	};
} = defineMessages({
	[NoticeMessage.Delete]: {
		id: 'ui-notices.confirmText.Delete',
		defaultMessage: 'Delete',
		description: 'Confirm button label for the delete action in a notice dialog',
	},
	[NoticeMessage.Discard]: {
		id: 'ui-notices.confirmText.Discard',
		defaultMessage: 'Discard',
		description: 'Confirm button label for the discard action in a notice dialog',
	},
	[NoticeMessage.Change]: {
		id: 'ui-notices.confirmText.Change',
		defaultMessage: 'Change',
		description: 'Confirm button label for the change action in a notice dialog',
	},
	[NoticeMessage.Confirm]: {
		id: 'ui-notices.confirmText.Confirm',
		defaultMessage: 'Confirm',
		description: 'Confirm button label for the confirm action in a notice dialog',
	},
	[NoticeMessage.Submit]: {
		id: 'ui-notices.confirmText.Submit',
		defaultMessage: 'Submit',
		description: 'Confirm button label for the submit action in a notice dialog',
	},
	[NoticeMessage.Reopen]: {
		id: 'ui-notices.confirmText.Reopen',
		defaultMessage: 'Reopen',
		description: 'Confirm button label for the reopen action in a notice dialog',
	},
	[NoticeMessage.Close]: {
		id: 'ui-notices.confirmText.Close',
		defaultMessage: 'Close',
		description: 'Confirm button label for the close action in a notice dialog',
	},
	[NoticeMessage.Cancel]: {
		id: 'ui-notices.confirmText.Cancel',
		defaultMessage: 'Cancel',
		description: 'Confirm button label for the cancel action in a notice dialog',
	},
	[NoticeMessage.UpgradeNow]: {
		id: 'ui-notices.confirmText.UpgradeNow',
		defaultMessage: 'Upgrade Now',
		description: 'Button label prompting the user to upgrade their plan in a notice dialog',
	},
	[NoticeMessage.MakeInternal]: {
		id: 'ui-notices.confirmText.MakeInternal',
		defaultMessage: 'Make internal',
		description: 'Button label to confirm making a form internal and hidden from customers',
	},
	[NoticeMessage.MakeExternal]: {
		id: 'ui-notices.confirmText.MakeExternal',
		defaultMessage: 'Make external',
		description: 'Button label to confirm making a form external and visible to customers',
	},
	[NoticeMessage.DeleteFormTitle]: {
		id: 'ui-notices.title.DeleteFormTitle',
		defaultMessage: 'Confirm Deleting Form',
		description: 'Title of the confirmation dialog shown before the user deletes a form',
	},
	[NoticeMessage.DeleteFormMsg]: {
		id: 'ui-notices.msg.DeleteFormMsg',
		defaultMessage: 'Are you sure you want to delete the "{formName}" form? This cannot be undone.',
		description: 'Confirmation message body asking the user to confirm deletion of the named form',
	},
	[NoticeMessage.ChangeFormAvailabilityTitle]: {
		id: 'ui-notices.title.ChangeFormAvailabilityTitle',
		defaultMessage: 'Confirm Changing Form Availability',
		description: 'Title of the confirmation dialog before changing a form availability setting',
	},
	[NoticeMessage.ChangeFormToInternalHeader]: {
		id: 'ui-notices.title.ChangeFormInternalHeader',
		defaultMessage: 'Make form internal only and hide from customer',
		description: 'Header in the dialog for making a form internal and hidden from customers',
	},
	[NoticeMessage.ChangeFormToInternalMsg]: {
		id: 'ui-notices.msg.ChangeFormInternalMsg',
		defaultMessage:
			'Any forms made internal will only be seen by agents and hidden in the portal from customers.',
		description: 'Body text explaining what happens when a form is made internal in the portal',
	},
	[NoticeMessage.ChangeFormToExternalHeader]: {
		id: 'ui-notices.title.ChangeFormToExternalHeader',
		defaultMessage: 'Make form external and show to customer',
		description: 'Header in the dialog for making a form external and visible to customers',
	},
	[NoticeMessage.ChangeFormToExternalMsg]: {
		id: 'ui-notices.msg.ChangeFormToExternalMsg',
		defaultMessage:
			'Customers will be able to view this form in the portal and it will no longer be internal only.',
		description: 'Body text explaining what happens when a form is made external in the portal',
	},
	[NoticeMessage.CancelEditFormTitle]: {
		id: 'ui-notices.title.CancelEditFormTitle',
		defaultMessage: 'Confirm Discarding Changes',
		description: 'Title of the confirmation dialog shown before discarding unsaved form edits',
	},
	[NoticeMessage.CancelEditFormMsg]: {
		id: 'ui-notices.msg.CancelEditFormMsg',
		defaultMessage:
			'There are changes to answers on the "{formName}" form that will be lost if you choose "Confirm". Are you sure you want to continue?',
		description:
			'Warning message body shown when discarding unsaved form edits, with the form name as a placeholder',
	},
	[NoticeMessage.SubmitFormTitle]: {
		id: 'ui-notices.title.SubmitFormTitle',
		defaultMessage: 'Confirm Form Submission',
		description: 'Title of the confirmation dialog shown before the user submits a form',
	},
	[NoticeMessage.SubmitFormMsg]: {
		id: 'ui-notices.msg.SubmitFormMsg',
		defaultMessage: 'Are you sure you want to submit this form ?',
		description:
			'Confirmation message body asking the user to confirm they want to submit the form',
	},
	[NoticeMessage.SubmitFormLockMsg]: {
		id: 'ui-notices.msg.SubmitFormLockMsg',
		defaultMessage:
			'Are you sure you want to submit this form ? Once submitted no further changes can be made.',
		description:
			'Confirmation message body warning the user that submitting the form will lock it from further edits',
	},
	[NoticeMessage.ReopenFormTitle]: {
		id: 'ui-notices.title.ReopenFormTitle',
		defaultMessage: 'Confirm Reopening Form',
		description:
			'Title of the confirmation dialog shown before the user reopens a submitted form for editing',
	},
	[NoticeMessage.ReopenFormMsg]: {
		id: 'ui-notices.msg.ReopenFormMsg',
		defaultMessage: 'Are you sure you want to reopen the submitted form for editing?',
		description:
			'Confirmation message body asking the user to confirm they want to reopen a submitted form',
	},
	[NoticeMessage.ErrorExplanations1]: {
		id: 'ui-notices.msg.ErrorExplanations1',
		defaultMessage: 'Please refer to our',
		description:
			'First segment of the error explanation sentence directing the user to documentation',
	},
	[NoticeMessage.ErrorExplanations2]: {
		id: 'ui-notices.msg.ErrorExplanations2',
		defaultMessage: 'Error Explanations',
		description:
			'Link text for the error explanations page, shown as part of an error support message',
	},
	[NoticeMessage.ErrorExplanations3]: {
		id: 'ui-notices.msg.ErrorExplanations3',
		defaultMessage: 'page for more details or contact',
		description:
			'Middle segment of the error support sentence between the doc link and the support contact link',
	},
	[NoticeMessage.ErrorExplanations4]: {
		id: 'ui-notices.msg.ErrorExplanations4',
		defaultMessage: 'ThinkTilt Support',
		description:
			'Link text for the ThinkTilt support team, shown as part of an error support message',
	},
});
